module.exports = __webpack_public_path__ + "static/media/portada720_1280_movil_grande.accf58d3.png";